'use strict';

var templates = require('../templates');
var fobclient = require('..');
var Forschungsbericht = require('../entity').Forschungsbericht;

module.exports = function (connection) {
  return {
    byIstFinalEquals: function byIstFinalEquals(istfinal, additionalParams) {
      return templates.searchTemplate(connection)(Forschungsbericht, 'byIstFinalEquals', 'istfinal')(istfinal, additionalParams);
    },
    byIstOffiziellEquals: function byIstOffiziellEquals(istoffiziell, additionalParams) {
      return templates.searchTemplate(connection)(Forschungsbericht, 'byIstOffiziellEquals', 'istoffiziell')(istoffiziell, additionalParams);
    },
    byOrganisationseinheitEquals: function byOrganisationseinheitEquals(organisationseinheit, additionalParams) {
      return templates.searchTemplate(connection)(Forschungsbericht, 'byOrganisationseinheitEquals', 'organisationseinheit')(organisationseinheit, additionalParams);
    },
    bySearchRepLike: function bySearchRepLike(rep, additionalParams) {
      return templates.searchTemplate(connection)(Forschungsbericht, 'bySearchRepLike', 'rep')(rep, additionalParams);
    },
    byTitelEquals: function byTitelEquals(titel, additionalParams) {
      return templates.searchTemplate(connection)(Forschungsbericht, 'byTitelEquals', 'titel')(titel, additionalParams);
    },
    byTitelLike: function byTitelLike(titel, additionalParams) {
      return templates.searchTemplate(connection)(Forschungsbericht, 'byTitelLike', 'titel')(titel, additionalParams);
    },
    byYearEquals: function byYearEquals(year, additionalParams) {
      return templates.searchTemplate(connection)(Forschungsbericht, 'byYearEquals', 'year')(year, additionalParams);
    },
    forForschungsbericht: function forForschungsbericht(orgaid, additionalParams) {
      return templates.searchTemplate(connection)(Forschungsbericht, 'forForschungsbericht', 'orgaid')(orgaid, additionalParams);
    },
    withGenericAnd: function withGenericAnd(searchParams) {
      return templates.genericSearchTemplate(connection)(Forschungsbericht, 'genericand')(searchParams);
    },
    byID: function byID(_id) {
      return fobclient.genericGet('forschungsbericht')(_id);
    }
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/fobclient/lib/find/forschungsbericht.js
// module id = y+v0
// module chunks = 0